module.exports = __webpack_public_path__ + "media/application/images/bonington_slider_bag-046c75b764a311bc02eb1ce9c1450e25.png";